export default "__VITE_ASSET__CEIF7KI___"